
import React from 'react'
import { Nav, Tab } from 'react-bootstrap'

import WeekNavigator from '@/Components/WeekNavigator/WeekNavigator'

import './ContentBodyHeader.scss'

interface IWeekNavigator {
  prev: string
  next: string
  week: number | string
}

interface IButton {
  icon: JSX.Element
  label: string
  onClick: () => void
  visible?: boolean
  active?: boolean
}

interface ITab {
  icon?: JSX.Element
  key: string
  label?: string
}

interface Props {
  title: string | JSX.Element
  weekNavigator?: IWeekNavigator
  onChangeWeek?: (week?: string) => void
  buttons?: IButton[]
  tabs?: ITab[]
  activeTabKey?: string
  onChangeTab?: (key: string) => void
  children?: any
}

const ContentBodyHeader = (props: Props) => {

  const {
    title,
    weekNavigator,
    buttons,
    tabs,
    activeTabKey,
    onChangeTab,
    onChangeWeek,
  } = props;

  return (
    <div className="content-body-header">
      <div className="left-part">
        {typeof title === 'string' && (
          <h3>
            {title}
          </h3>
        )}
        {typeof title !== 'string' && title}
      </div>
      <div className="right-part">
        {weekNavigator && onChangeWeek && (
          <WeekNavigator
            prev={weekNavigator.prev}
            next={weekNavigator.next}
            current={weekNavigator.week}
            onChangeWeek={onChangeWeek}
          />
        )}
        {buttons && (
          <div className="content-body-header-buttons">
            {buttons.map((button: IButton, i: number) => button.visible && (
              <button
                key={i}
                className={`btn btn-link btn-link-header ${button.active && 'active'}`}
                onClick={button.onClick}
                disabled={!button.active}
              >
                {button.icon}
                <span className="d-none d-md-inline"> {button.label}</span>
              </button>
            ))}
          </div>
        )}
        {tabs && (
          <Tab.Container defaultActiveKey={activeTabKey}>
            <Nav variant="pills" className="content-body-header-tabs">
              {tabs.map((tab: ITab, i: number) => (
                <Nav.Item key={i}>
                  <Nav.Link active={tab.key === activeTabKey} onClick={() => onChangeTab && onChangeTab(tab.key)}>
                    {tab.icon}
                    {tab.label && <span className="hide-on-mobile"> {tab.label}</span>}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Tab.Container>
        )}
      </div>
    </div>
  )
}

export default ContentBodyHeader
